import { Response, Server } from 'miragejs';

import {
  linkedAssetThatFailsToActivate,
  linkedAssetThatFailsToActivateNoDraft,
  linkedAssetThatFailsToArchive,
  linkedAssetThatFailsToArchiveNoDraft,
  linkedAssetThatFailsToDeactivate,
  linkedAssetThatFailsToDeactivateNoDraft,
  linkedAssetThatFailsToUnarchive,
  linkedAssetThatFailsToUnarchiveNoDraft,
} from 'mocks/server/data/linkedAssets';
import LocalStorageManager from 'mocks/server/localStorageManager';
import { handleSetStatus } from 'mocks/server/utils/entityUtils';
import { ILiveLinkedAsset } from 'types/detailsEntityType';
import {
  LINKED_ASSETS_ACTIVATE_API_URL,
  LINKED_ASSETS_API_URL,
  LINKED_ASSETS_ARCHIVE_API_URL,
  LINKED_ASSETS_DEACTIVATE_API_URL,
  LINKED_ASSETS_UNARCHIVE_API_URL,
} from 'utils/defaults';
import { LiveStatus } from 'utils/statuses';

export const linkedAssetsRoutes = (
  server: Server,
  linkedAssetStore: LocalStorageManager<ILiveLinkedAsset>
) => {
  server.get(`${LINKED_ASSETS_API_URL}/:spaceId`, (schema, request) => {
    const spaceId = request.params.spaceId;
    const linkedAsset = linkedAssetStore.getById(spaceId);
    if (!linkedAsset) {
      return new Response(404, {}, { error: 'Linked Asset not found' });
    }
    return linkedAsset;
  });

  server.patch(LINKED_ASSETS_DEACTIVATE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [linkedAssetThatFailsToDeactivate.spaceId],
      [linkedAssetThatFailsToDeactivateNoDraft.spaceId],
      'deactivation',
      linkedAssetStore,
      LiveStatus.INACTIVE
    );
  });

  server.patch(LINKED_ASSETS_ACTIVATE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [linkedAssetThatFailsToActivate.spaceId],
      [linkedAssetThatFailsToActivateNoDraft.spaceId],
      'activation',
      linkedAssetStore,
      LiveStatus.ACTIVE
    );
  });

  server.patch(LINKED_ASSETS_ARCHIVE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [linkedAssetThatFailsToArchive.spaceId],
      [linkedAssetThatFailsToArchiveNoDraft.spaceId],
      'archiving',
      linkedAssetStore,
      LiveStatus.ARCHIVED
    );
  });

  server.patch(LINKED_ASSETS_UNARCHIVE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [linkedAssetThatFailsToUnarchive.spaceId],
      [linkedAssetThatFailsToUnarchiveNoDraft.spaceId],
      'unarchiving',
      linkedAssetStore,
      LiveStatus.INACTIVE
    );
  });
};
